import { useMutation } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import { $apiWithoutClient, errorHandler, globalConst } from 'modules/global';

export function useFinishOlympicTest() {
  const { push } = useRouter();

  return useMutation({
    mutationFn: async (ticketId?: number) => {
      const { data } = await $apiWithoutClient.post(`/olympic/olympic-finish-test`, { ticket_id: ticketId });

      return data;
    },
    onSuccess(data) {
      push(`${globalConst.pageNames.ONLINE_OLYMPIC}/olimpiada-${data?.olympic_id}/natijalar`);
    },
    onError: errorHandler()
  });
}
